import axiosInstance from './axios'
import { errorMessageToast } from "helpers/common"
import { logout } from "store/slices/authSlice"
import apiRegistry from "utils/apiRegistry";
import { recordApiActivity } from "utils/sessionActivity";

const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: '' }) =>
    async (arg, { dispatch }, extraOptions) => {
      try {
        const config = typeof arg === "string" ? { url: arg } : arg;
        let { url, method = 'GET', data = undefined, params = null, headers = {} } = config;

        const result = await axiosInstance({
          url: baseUrl + url,
          method,
          data,
          params,
          headers,
        })
        if (result?.status !== "success") {
          throw new Error("Response was not ok")
        }

        // record api acitivity for auto logout
        recordApiActivity();

        return {
          data: result || null,
        }
      } catch (axiosError) {
        console.error("Error occurred in API request: ", axiosError);
        const err = axiosError;
        if (err?.status === 401) {
          console.log(401)
          apiRegistry.forEach(api => dispatch(api.util.resetApiState()))
          dispatch(logout());
          return;
        }
        else if (err.code === "ERR_NETWORK") {
          errorMessageToast("Network error. Please check your internet connection.", { toastId: "networkErrorToast" });
        }
        else if (!extraOptions?.suppressErrorToast) {
          errorMessageToast(err.response?.data?.message || err.message, { toastId: "apiErrorToast" });
        }
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        }
      }
    }

export default axiosBaseQuery;